module.exports = __webpack_public_path__ + "static/media/thumb.a1e55c4f.jpg";